module.exports = __webpack_public_path__ + "static/media/Guatemala.aaa5c966.png";